module.exports = __webpack_public_path__ + "img/subscription.a2ee2ede.png";